import React from 'react';
import { UserProvider } from './UserContext';
import { CourseProvider } from './CourseContext';
import { LiveClassProvider } from './LiveClassContext';
import { SubscriptionProvider } from './SubscriptionContext';
import { PaymentProvider } from './PaymentContext';
import { CouponProvider } from './CouponContext';
import { LoadingProvider } from './LoadingContext';
import { SocketProvider } from './SocketContext'; // Import SocketProvider
import ErrorBoundary from '../Components/ErrorBoundary/ErrorBoundary';
import { BrandingProvider } from './BrandingContext';

// Optimized provider composition to reduce nesting and improve performance
const AppProviders = ({ children }) => {
  return (
    <ErrorBoundary>
      <LoadingProvider>
        <UserProvider>
          <SocketProvider>
            <CourseProvider>
              <LiveClassProvider>
                <SubscriptionProvider>
                  <PaymentProvider>
                    <CouponProvider>
                      <BrandingProvider>
                        {children}
                      </BrandingProvider>
                    </CouponProvider>
                  </PaymentProvider>
                </SubscriptionProvider>
              </LiveClassProvider>
            </CourseProvider>
          </SocketProvider>
        </UserProvider>
      </LoadingProvider>
    </ErrorBoundary>
  );
};

export default AppProviders;
